/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guestlist_BodyInputs */

const en_guestlist_body = /** @type {(inputs: Guestlist_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take Backstage and give it the buyers: every account with its brands, visits, emails and orders on one timeline. Invite a whole market week, watch the bookings arrive, and follow each guest from the invitation to the invoice.`)
};

/**
* | output |
* | --- |
* | "Take Backstage and give it the buyers: every account with its brands, visits, emails and orders on one timeline. Invite a whole market week, watch the bookin..." |
*
* @param {Guestlist_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guestlist_body = /** @type {((inputs?: Guestlist_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guestlist_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guestlist_body(inputs)
});